import React from 'react'
import { useSelector } from 'react-redux'
// import { GLOBALTYPES } from '../../redux/actions/globalTypes'
import saberToast from './Toast'
import '../../styles/toaster.css'
import Loading from '../loading/loading'

const Alert = () => {
    const alert = useSelector(state => state.alert)
    const payment = useSelector(state => state.payment?.loading)
    // const dispatch = useDispatch()

    return (
        <div className='alert-container'>

            {payment && <Loading className='alert-container loading' />}


            {
                alert.error && (
                    saberToast.error({
                        title: 'Error',
                        text: alert.error,
                        delay: 200,
                        duration: 2000,
                        position: "top-right"
                    })
                )
            }
            {
                alert.success && (
                    saberToast.success({
                        title: 'success',
                        text: alert.success,
                        delay: 200,
                        duration: 2000,
                        position: "top-right"
                    })
                )
            }
        </div>
    )
}



export default Alert
